import styled from 'styled-components';

const FlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export default FlexRowContainer;
